import { SocialMediaLinkProps } from '../../interfaces/index'
import { IconProp } from '@fortawesome/fontawesome-svg-core'

type MenuItemProps = {
  key: string
  label: string
  href: string
  external?: boolean
}

type LegalLinksProps = {
  key: string
  label: string
  href: string
  external?: boolean
}

export const menuItems: MenuItemProps[] = [
  {
    key: '1',
    label: 'Home',
    href: '/home',
  },
  {
    key: '2',
    label: 'Training Guide',
    href: '/training-guide',
  },
  {
    key: '3',
    label: 'FAQ',
    href: '/FAQs',
  },
  {
    key: '4',
    label: 'Contact Us',
    href: '/contact-us',
  },
]

export const socialMediaLinks: SocialMediaLinkProps[] = [
  {
    key: '1',
    id: 'youtube',
    icon: ['fab', 'youtube'] as IconProp,
    href: 'https://www.youtube.com/watch?v=7ss7JOXaqz8',
  },
  {
    key: '2',
    id: 'linkedin',
    icon: ['fab', 'linkedin'],
    href: 'https://www.linkedin.com/company/avalonai/mycompany/',
  },
  {
    key: '3',
    id: 'envelope',
    icon: 'envelope',
    href: 'https://avalonai.co/contact-us/',
    label: 'info@avalonai.co',
  },
] as const

export const legalLinks: LegalLinksProps[] = [
  {
    key: '1',
    label: 'Terms of Use',
    href: '/legal/terms-of-use',
  },
  {
    key: '2',
    label: 'Cookie Disclaimer',
    href: '/legal/cookie-disclaimer',
  },
  {
    key: '3',
    label: 'Cookie Policy',
    href: '/legal/cookie-policy',
  },
]
